import { render, staticRenderFns } from "./InformationReceiving.vue?vue&type=template&id=ce3c2d22&scoped=true&"
import script from "./InformationReceiving.vue?vue&type=script&lang=js&"
export * from "./InformationReceiving.vue?vue&type=script&lang=js&"
import style0 from "./InformationReceiving.vue?vue&type=style&index=0&id=ce3c2d22&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3c2d22",
  null
  
)

export default component.exports